import { useEffect, useState } from 'react';
import useScript from './useScript';

const IOVATION_CONFIG = {
  bbout_element_id: 'ioBlackBox',
  enable_rip: true,
  enable_flash: false,
  install_flash: false,
  loader: {
    version: 'general5',
  },
};

const useIoBlackbox = (): string | undefined => {
  const [ioBlackbox, setIoBlackbox] = useState<string | undefined>();
  const status = useScript(`${process.env.PUBLIC_URL}/js/iojs-loader.js`);

  useEffect(() => {
    if (process.env.REACT_APP_IOVATION_SERVER_INTEGRATION !== 'true') {
      /** Loads iovation scripts from current domain proxy or from third-party domain */
      Object.assign(IOVATION_CONFIG, {
        loader: {
          fp_static: false,
          version: 'general5',
        },
      });
    }

    if (!window.IGLOO) window.IGLOO = IOVATION_CONFIG;

    window.IGLOO.bb_callback = function (
      blackBoxString: string,
      isComplete: boolean,
    ) {
      if (isComplete) {
        setIoBlackbox(blackBoxString);
      }
    };
  }, [status]);

  return ioBlackbox;
};

export default useIoBlackbox;
